import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, tap } from 'rxjs';
import { getCompanies, setSelectedCompany } from '../../store/auth.actions';
import { selectCompanies, selectUserProfile } from '../../store/auth.selectors';
import { Company } from '../auth.models';
import { AuthService } from '../auth.service';

/**
 * Resolves the currently selected Client account.
 * If none selected picks one from the list of clients the current user is a member of.
 *
 * Selection is based on either: navigated URL's `client` parameter, localStorage's `client` value
 * or if neither is present default to the first available entry in the list
 */
export const resolveAccount: ResolveFn<Company | undefined> = route => {
  const store = inject(Store);
  const auth = inject(AuthService);

  return combineLatest([store.select(selectCompanies), store.select(selectUserProfile)]).pipe(
    tap(([accounts]) => {
      if (accounts.untouched) store.dispatch(getCompanies());
    }),
    filter(([allAccounts, user]) => !!user && !!allAccounts.value),
    map(([allAccounts]) => {
      const accountURI = route.queryParamMap.get('client') ?? auth.selectedAccount;
      const accountFound = (allAccounts.value ?? []).find(acc => acc.company_name === accountURI);

      if (accountFound) {
        store.dispatch(setSelectedCompany({ company: accountFound }));
        auth.selectedAccount = accountFound.company_name;
      }

      return accountFound;
    })
  );
};
